// Fino — Hardcoded variant colour swatches (self-styling, no custom CSS needed)
(function () {
  'use strict';

  const COLOR_MAP = {
    'onyx': '#0A0A0A',
    'midnight': '#1B2838',
    'graphite': '#3C3F44',
    'harbor': '#264653',
    'ceil': '#A3B9CB',
    'bone': '#E8E2D5',
    'moss': '#4A5B3E',
    'claret': '#5E1F2A',
    'mauve': '#8B6F78',
  };

  function injectStyles() {
    if (document.getElementById('fino-swatch-styles')) return;
    const style = document.createElement('style');
    style.id = 'fino-swatch-styles';
    style.textContent = `
      variant-picker fieldset label[data-fino-swatched="true"] {
        width: 28px;
        height: 28px;
        min-width: 28px;
        padding: 0 !important;
        border-radius: 50%;
        border: 1.5px solid #E4E1DB;
        cursor: pointer;
        position: relative;
        transition: transform 0.15s ease, box-shadow 0.15s ease;
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
      variant-picker fieldset label[data-fino-swatched="true"]:hover {
        transform: scale(1.08);
      }
      variant-picker fieldset input[type="radio"]:checked + label[data-fino-swatched="true"],
      variant-picker fieldset label[data-fino-swatched="true"]:has(input[type="radio"]:checked) {
        box-shadow: 0 0 0 2px #fff, 0 0 0 3.5px var(--swatch-ring, #0A0A0A);
      }
      variant-picker fieldset:has(label[data-fino-swatched="true"]) {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        align-items: center;
      }
    `;
    document.head.appendChild(style);
  }

  function hexFor(name) {
    if (!name) return null;
    return COLOR_MAP[name.trim().toLowerCase()] || null;
  }

  function isColorFieldset(fieldset) {
    const legend = fieldset.querySelector('legend');
    const legendText = legend ? legend.textContent.toLowerCase() : '';
    const ariaLabel = (fieldset.getAttribute('aria-label') || '').toLowerCase();
    const dataName = (fieldset.dataset.optionName || '').toLowerCase();
    return /colou?r/.test(legendText + ' ' + ariaLabel + ' ' + dataName);
  }

  function isHexDark(hex) {
    const h = hex.replace('#', '');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 < 140;
  }

  function paintLabel(label, hex) {
    label.style.setProperty('background-color', hex, 'important');
    label.dataset.finoSwatched = 'true';

    label.querySelectorAll('span, div').forEach((el) => {
      if (el.children.length === 0 && el.textContent.trim().length > 0) {
        if (!el.dataset.finoOriginalText) el.dataset.finoOriginalText = el.textContent;
        el.style.setProperty('color', 'transparent', 'important');
        el.style.setProperty('font-size', '0', 'important');
      }
    });

    label.style.setProperty('--swatch-ring', isHexDark(hex) ? '#ffffff' : '#0A0A0A');
  }

  function processColorFieldset(fieldset) {
    fieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
      let label = radio.id ? fieldset.querySelector(`label[for="${radio.id}"]`) : null;
      if (!label) label = radio.closest('label') || radio.nextElementSibling;
      if (!label) return;
      const variantName = radio.value || label.textContent.trim();
      const hex = hexFor(variantName);
      if (hex) paintLabel(label, hex);
    });
  }

  function processAll() {
    document.querySelectorAll('variant-picker').forEach((picker) => {
      picker.querySelectorAll('fieldset').forEach((fieldset) => {
        if (isColorFieldset(fieldset)) processColorFieldset(fieldset);
      });
    });
  }

  injectStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  ['variant-selected', 'variant-update', 'variant:change', 'variantchange'].forEach((evt) => {
    document.addEventListener(evt, () => setTimeout(processAll, 30));
  });

  if ('MutationObserver' in window) {
    const attach = (picker) => {
      if (picker.__finoSwatchObserver) return;
      const obs = new MutationObserver(() => {
        clearTimeout(window.__finoSwatchTimer);
        window.__finoSwatchTimer = setTimeout(processAll, 40);
      });
      obs.observe(picker, { childList: true, subtree: true });
      picker.__finoSwatchObserver = obs;
    };
    document.querySelectorAll('variant-picker').forEach(attach);
    new MutationObserver((mutations) => {
      mutations.forEach((m) => m.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('variant-picker')) attach(n);
        else if (n.querySelectorAll) n.querySelectorAll('variant-picker').forEach(attach);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }
})();